import { Employee, EmployeeService } from "../api/generated";
import { SearchBar, SearchQuery, ymdDash } from "./search_bar";
import { EmployeeSearchTable } from "./employeeSearchTable";
import { useState } from "react";
import { format } from "date-fns";

export type RegisterStepOneState =
  | { state: "INITIAL" }
  | { state: "LOADING" }
  | { state: "READY"; searchResult: Employee[] }
  | { state: "ERROR"; error: Error };

interface RegisterStepOneProps {
  onSelectEmployee: (employee: Employee) => void;
}

export const EmployeeRegisterStepOne = ({
  onSelectEmployee,
}: RegisterStepOneProps) => {
  const [state, setState] = useState<RegisterStepOneState>({
    state: "INITIAL",
  });

  const search = async (query: SearchQuery) => {
    setState({ state: "LOADING" });

    try {
      const result = await EmployeeService.getEmployees(
        query.query || undefined,
        mapDate(query.date) || undefined,
      );
      setState({ state: "READY", searchResult: result });
    } catch (error) {
      console.log(error);
      setState({ state: "ERROR", error: error as Error });
    }
  };

  const mapDate = (date: Date | null) => {
    if (!date) {
      return undefined;
    }
    return format(date, ymdDash);
  };

  return (
    <>
      <div className="mt-6">
        <SearchBar search={search} autoFocus={true} />
      </div>
      <div className="mt-6 w-full">
        {state.state === "INITIAL" && (
          <p className="text-gray-500 text-center">Zoek naar medewerkers</p>
        )}
        {state.state === "LOADING" && (
          <p className="text-gray-500 text-center">Laden...</p>
        )}
        {state.state === "ERROR" && (
          <p className="text-red-500 text-center">
            Fout: {state.error.message}
          </p>
        )}
        {state.state === "READY" && state.searchResult.length === 0 && (
          <p className="text-center">Geen medewerkers gevonden</p>
        )}

        {state.state === "READY" && state.searchResult.length > 0 && (
          <EmployeeSearchTable
            employees={state.searchResult}
            itemsPerPage={15}
            navigator={(id) => {
              const selectedEmployee = state.searchResult.find(
                (employee) => employee.id === id,
              );
              if (selectedEmployee) {
                onSelectEmployee(selectedEmployee);
              }
            }}
          />
        )}
      </div>
    </>
  );
};
